import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';
import styled, { DefaultTheme } from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import { primitive } from 'styles/constants/primitives';

import { IFilter } from './types';

interface TagProps {
  theme: DefaultTheme;
}

const Container = styled(ClickableContainer)`
  grid-area: tags;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  min-height: 0;
  padding-block-start: ${primitive.$spacing4};
  padding-block-end: 0;
  padding-inline: ${primitive.$spacing2};

  ${Styles.desktop} {
    padding-block-start: ${primitive.$spacing2};
    padding-block-end: 0;
    padding-inline: ${primitive.$spacing4};
    min-height: 2.5rem;
  }
`;

const Tag = styled.button<TagProps>`
  padding: ${primitive.$spacing1} ${primitive.$spacing2};
  margin-inline-end: ${primitive.$spacing1};
  margin-block-end: ${primitive.$spacing1};

  cursor: pointer;
  font: ${p => p.theme.token('text-style-chip')};
  font-weight: bold;
  font-family: ${Styles.fontFamily.base};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  background: none;
  background-color: ${p => p.theme.token('background-chip')};
  color: ${p => p.theme.token('text-reversed')};
  text-transform: uppercase;
  border: none;
  border-radius: 4px;

  ${Styles.desktop} {
    font: ${p => p.theme.token('text-style-form-label-value')};
    font-weight: bold;
  }
`;

interface ITags {
  activeModalFilters: IFilter[];
  openFilterModal: VoidFunction;
}

export const Tags: React.FC<ITags> = ({ activeModalFilters, openFilterModal }) => {
  const { formatMessage } = useIntl();

  const filterTags = useMemo(() => {
    return activeModalFilters.map(filter => filter.description.locale);
  }, [activeModalFilters]);

  return (
    <Container data-testid="tags-container" aria-label={formatMessage({ id: 'filterTags' })}>
      {filterTags.map(tag => (
        <Tag key={tag} onClick={openFilterModal}>
          {tag}
        </Tag>
      ))}
    </Container>
  );
};
